import { SearchConstraintDTO } from 'business/models/Models';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import { RuleGroupType } from 'react-querybuilder';
import { FilterOptions } from './TaskOption/QueryComponents';

export const ActionOperationType = {
  0: 'Move',
  1: 'Copy',
  2: 'Delete',
};

export const ActionOperationValue = {
  Move: 0,
  Copy: 1,
  Delete: 2,
};

export enum ExcludeInspections {
  FIRSTINSPECTION = 'First Inspection',
  LASTINSPECTION = 'Last Inspection',
}

export const buttonsIconSize = { width: '75', height: '30' };

export const exludedNodesList = [
  ETreeNodeTypes.QuickAccess,
  ETreeNodeTypes.Screens,
  ETreeNodeTypes.SynchrotronTripv4,
  ETreeNodeTypes.SynchrotronTripv4Folder,
  ETreeNodeTypes.CrystalTrackv4,
  ETreeNodeTypes.Searches,
  ETreeNodeTypes.RecycleBin,
];

export const newDefaultTaskName = 'New Image Management Task';

export const loadTask = {
  id: 0,
  title: 'Load File',
  value: 'Load File',
  parentId: 0,
  treeNodeId: 0,
  errorBehaviour: 0,
  isBackground: false,
  imageManagementActionList: [],
};

export const imageTaskNameKey = 'taskName';

export const defaultOption = {
  id: -1,
  title: 'Select',
  value: 'Select',
};

export const noneOption = {
  id: 0,
  title: 'None',
  value: '',
};

export const constraintsTarget = {
  imageSetting: 'Capture Result',
  score: 'Well Drop Score',
  image: 'Image',
  plate: 'Plate',
};
export const constraintsDisplayName = {
  imageSetting: 'Profile Name',
  scoreGroups: 'Group Name',
  score: 'Name',
  imageTypeShortName: 'Type Short Name',
  plateState: 'Plate State',
  dateImaged: 'Date Imaged',
};

export const defaultSelectedValue = {
  id: 0,
  name: 'Select',
};

export const constraintsInitialState: RuleGroupType | SearchConstraintDTO = {
  combinator: 'and',
  rules: [],
};

export const onErrorTypeOptions = [
  {
    id: 0,
    title: 'Ignore and continue',
    value: 'Ignore and continue',
  },
  {
    id: 1,
    title: 'Abort after current action completes',
    value: 'Abort after current action completes',
  },
  {
    id: 2,
    title: 'Abort immediately',
    value: 'Abort immediately',
  },
];

export enum EConstraintType {
  Default = 0,
  OlderThanDays = 1,
}

export enum EConstraintOverrideType {
  Number = 'number',
  Boolean = 'boolean', // TODO: Use this for Exclude First Inspection/Last Inspection toggles
}

export enum JobTypeDTO {
  AutoScoring,
  DisputeScore,
  ImageManangement,
  LongRunningTask,
  FindOrphanImages,
  ImageManangementAction,
  AutoScoringEmails,
  EnqueuRetrainImages,
  StorageInfo,
  AccessRights,
  ExperimentReport,
  HitCountRecalculation,
  Archiving,
  Unarchive,
}

export const filterNoneOption: FilterOptions = {
  id: noneOption.id,
  value: noneOption.value,
  text: noneOption.title,
  group: '',
};

// HACK: Would be better if there's a way to sync data with BE/DB instead of hardcoding
// Image Type Short Name options for IMT Basic Filter
export const imageTypeShortNameOptions: FilterOptions[] = [
  { ...filterNoneOption },
  {
    id: 1,
    value: 'fl',
    text: 'fl (Focus Level)',
    group: '',
  },
  {
    id: 2,
    value: 'ef',
    text: 'ef (Extended Focus)',
    group: '',
  },
  {
    id: 3,
    value: 'bf',
    text: 'bf (Best Focus)',
    group: '',
  },
  {
    id: 4,
    value: 'dl',
    text: 'dl (Drop Location)',
    group: '',
  },
  {
    id: 5,
    value: 'th',
    text: 'th (Thumbnail)',
    group: '',
  },
];
